import { FC, useEffect, useState } from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import { useStyles } from "./style";
import { CardBlock, MainBlock, RejectedGraphBlock, StatsBlock } from "./DashboardStatsBlocks";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { handlegetDashboardStats } from "./requests";
import Loader from "router/components/Loader";
import { useDashboardStats } from "hooks/useDashboardStats";
import { useDisplayDashboardFilters } from "hooks/useDisplayDashboardFilters";

interface PropsType {}

const DashboardBody: FC<PropsType> = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [requestData, setRequestData] = useState<any>(null);
  const combinedFilterString = useDisplayDashboardFilters();
  const { dashboardSettings } = useTypeSelectors((state) => state.dashboard);


  const { routeData, deliveryData, returnsData, rabbitData, dollyData, daData, fleetData } =
    useDashboardStats(requestData);

  useEffect(() => {
    const params = {
      stations: dashboardSettings?.stations?.join("_"),
      ...(dashboardSettings?.filterType === "month" && {
        month: +Number(dashboardSettings.dateFilters?.month.split("-")[1]),
        year: +Number(dashboardSettings.dateFilters?.month.split("-")[0]),
      }),
      ...(dashboardSettings?.filterType === "week" && {
        week: +Number(dashboardSettings.dateFilters?.week.split("-W")[1]) - 1,
        year: +Number(dashboardSettings.dateFilters?.week.split("-W")[0]),
      }),
      ...(dashboardSettings?.filterType === "date" && {
        day: dashboardSettings.dateFilters?.date,
      }),
      ...(dashboardSettings?.filterType === "year" && {
        year: +Number(dashboardSettings.dateFilters?.year),
      }),
    };
    handlegetDashboardStats(params, setLoading, setRequestData);
  }, [
    dashboardSettings?.filterType,
    dashboardSettings.dateFilters?.date,
    dashboardSettings.dateFilters?.week,
    dashboardSettings.dateFilters?.month,
    dashboardSettings.dateFilters?.year,
    dashboardSettings?.stations,
  ]);

  return (
    <Box className={classes.body}>
      <Loader isLoading={loading} />
      <Box className={classes.filterDisplay}>
        <Typography className={classes.filterDisplayText}>{combinedFilterString}</Typography>
      </Box>
      <Grid className={classes.gridContainer} spacing={2} container>
        <Grid item sm={12} md={12} lg={8}>
          <Grid className={classes.gridContainer} spacing={2} container>
            <Grid item sm={12} md={12} lg={12} className={classes.gridItem}>
              <MainBlock data={routeData} />
            </Grid>
            <Grid item sm={12} md={6} lg={6} className={classes.gridItem}>
              <CardBlock data={deliveryData} hasModalOne hasModalTwo />
            </Grid>
            <Grid item sm={12} md={6} lg={6} className={classes.gridItem}>
              <CardBlock data={returnsData} hasModalOne hasModalTwo />
            </Grid>
            <Grid item sm={12} md={6} lg={6} className={classes.gridItem}>
              <RejectedGraphBlock title={"Rejected Shifts By All"} />
            </Grid>
            <Grid item sm={12} md={6} lg={6} className={classes.gridItem}>
              <RejectedGraphBlock title={"Rejected Shifts By DA"} hasDravierFilter />
            </Grid>
          </Grid>
        </Grid>
        <Grid item sm={12} md={12} lg={4}>
          <Grid className={classes.gridContainer} spacing={2} container>
            <Grid item sm={12} md={6} lg={12} className={classes.gridItem}>
              <StatsBlock data={fleetData} hasModalTwo hasBottomBorder />
            </Grid>
            <Grid item sm={12} md={6} lg={12} className={classes.gridItem}>
              <StatsBlock data={daData} hasModalTwo hasBottomBorder />
            </Grid>
            <Grid item sm={12} md={6} lg={12} className={classes.gridItem}>
              <StatsBlock data={rabbitData} hasBottomBorder />
            </Grid>
            <Grid item sm={12} md={6} lg={12} className={classes.gridItem}>
              <StatsBlock data={dollyData} hasBottomBorder />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardBody;
